import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import { defaultLanguage, fallbackLanguage } from './config';

// 导入翻译资源
import zhCommon from './locales/zh/common.json';
import zhEditor from './locales/zh/editor.json';
import zhPages from './locales/zh/pages.json';
import zhToolbar from './locales/zh/toolbar.json';

import enCommon from './locales/en/common.json';
import enEditor from './locales/en/editor.json';
import enPages from './locales/en/pages.json';
import enToolbar from './locales/en/toolbar.json';

import zhTWCommon from './locales/zh-TW/common.json';
import zhTWEditor from './locales/zh-TW/editor.json';
import zhTWPages from './locales/zh-TW/pages.json';
import zhTWToolbar from './locales/zh-TW/toolbar.json';

import jaCommon from './locales/ja/common.json';
import jaEditor from './locales/ja/editor.json';
import jaPages from './locales/ja/pages.json';
import jaToolbar from './locales/ja/toolbar.json';

import koCommon from './locales/ko/common.json';
import koEditor from './locales/ko/editor.json';
import koPages from './locales/ko/pages.json';
import koToolbar from './locales/ko/toolbar.json';

import esCommon from './locales/es/common.json';
import esEditor from './locales/es/editor.json';
import esPages from './locales/es/pages.json';
import esToolbar from './locales/es/toolbar.json';

import ptCommon from './locales/pt/common.json';
import ptEditor from './locales/pt/editor.json';
import ptPages from './locales/pt/pages.json';
import ptToolbar from './locales/pt/toolbar.json';

import frCommon from './locales/fr/common.json';
import frEditor from './locales/fr/editor.json';
import frPages from './locales/fr/pages.json';
import frToolbar from './locales/fr/toolbar.json';

import deCommon from './locales/de/common.json';
import deEditor from './locales/de/editor.json';
import dePages from './locales/de/pages.json';
import deToolbar from './locales/de/toolbar.json';

import hiCommon from './locales/hi/common.json';
import hiEditor from './locales/hi/editor.json';
import hiPages from './locales/hi/pages.json';
import hiToolbar from './locales/hi/toolbar.json';

import ruCommon from './locales/ru/common.json';
import ruEditor from './locales/ru/editor.json';
import ruPages from './locales/ru/pages.json';
import ruToolbar from './locales/ru/toolbar.json';

import arCommon from './locales/ar/common.json';
import arEditor from './locales/ar/editor.json';
import arPages from './locales/ar/pages.json';
import arToolbar from './locales/ar/toolbar.json';

import idCommon from './locales/id/common.json';
import idEditor from './locales/id/editor.json';
import idPages from './locales/id/pages.json';
import idToolbar from './locales/id/toolbar.json';

import bnCommon from './locales/bn/common.json';
import bnEditor from './locales/bn/editor.json';
import bnPages from './locales/bn/pages.json';
import bnToolbar from './locales/bn/toolbar.json';

import itCommon from './locales/it/common.json';
import itEditor from './locales/it/editor.json';
import itPages from './locales/it/pages.json';
import itToolbar from './locales/it/toolbar.json';

import trCommon from './locales/tr/common.json';
import trEditor from './locales/tr/editor.json';
import trPages from './locales/tr/pages.json';
import trToolbar from './locales/tr/toolbar.json';

import viCommon from './locales/vi/common.json';
import viEditor from './locales/vi/editor.json';
import viPages from './locales/vi/pages.json';
import viToolbar from './locales/vi/toolbar.json';

import thCommon from './locales/th/common.json';
import thEditor from './locales/th/editor.json';
import thPages from './locales/th/pages.json';
import thToolbar from './locales/th/toolbar.json';

import plCommon from './locales/pl/common.json';
import plEditor from './locales/pl/editor.json';
import plPages from './locales/pl/pages.json';
import plToolbar from './locales/pl/toolbar.json';

import ukCommon from './locales/uk/common.json';
import ukEditor from './locales/uk/editor.json';
import ukPages from './locales/uk/pages.json';
import ukToolbar from './locales/uk/toolbar.json';

import msCommon from './locales/ms/common.json';
import msEditor from './locales/ms/editor.json';
import msPages from './locales/ms/pages.json';
import msToolbar from './locales/ms/toolbar.json';

import nlCommon from './locales/nl/common.json';
import nlEditor from './locales/nl/editor.json';
import nlPages from './locales/nl/pages.json';
import nlToolbar from './locales/nl/toolbar.json';

import urCommon from './locales/ur/common.json';
import urEditor from './locales/ur/editor.json';
import urPages from './locales/ur/pages.json';
import urToolbar from './locales/ur/toolbar.json';

import faCommon from './locales/fa/common.json';
import faEditor from './locales/fa/editor.json';
import faPages from './locales/fa/pages.json';
import faToolbar from './locales/fa/toolbar.json';

import tlCommon from './locales/tl/common.json';
import tlEditor from './locales/tl/editor.json';
import tlPages from './locales/tl/pages.json';
import tlToolbar from './locales/tl/toolbar.json';

import haCommon from './locales/ha/common.json';
import haEditor from './locales/ha/editor.json';
import haPages from './locales/ha/pages.json';
import haToolbar from './locales/ha/toolbar.json';

const resources = {
  zh: {
    common: zhCommon,
    editor: zhEditor,
    pages: zhPages,
    toolbar: zhToolbar,
  },
  en: {
    common: enCommon,
    editor: enEditor,
    pages: enPages,
    toolbar: enToolbar,
  },
  'zh-TW': {
    common: zhTWCommon,
    editor: zhTWEditor,
    pages: zhTWPages,
    toolbar: zhTWToolbar,
  },
  ja: {
    common: jaCommon,
    editor: jaEditor,
    pages: jaPages,
    toolbar: jaToolbar,
  },
  ko: {
    common: koCommon,
    editor: koEditor,
    pages: koPages,
    toolbar: koToolbar,
  },
  es: {
    common: esCommon,
    editor: esEditor,
    pages: esPages,
    toolbar: esToolbar,
  },
  pt: {
    common: ptCommon,
    editor: ptEditor,
    pages: ptPages,
    toolbar: ptToolbar,
  },
  fr: {
    common: frCommon,
    editor: frEditor,
    pages: frPages,
    toolbar: frToolbar,
  },
  de: {
    common: deCommon,
    editor: deEditor,
    pages: dePages,
    toolbar: deToolbar,
  },
  hi: {
    common: hiCommon,
    editor: hiEditor,
    pages: hiPages,
    toolbar: hiToolbar,
  },
  ru: {
    common: ruCommon,
    editor: ruEditor,
    pages: ruPages,
    toolbar: ruToolbar,
  },
  ar: {
    common: arCommon,
    editor: arEditor,
    pages: arPages,
    toolbar: arToolbar,
  },
  id: {
    common: idCommon,
    editor: idEditor,
    pages: idPages,
    toolbar: idToolbar,
  },
  bn: {
    common: bnCommon,
    editor: bnEditor,
    pages: bnPages,
    toolbar: bnToolbar,
  },
  it: {
    common: itCommon,
    editor: itEditor,
    pages: itPages,
    toolbar: itToolbar,
  },
  tr: {
    common: trCommon,
    editor: trEditor,
    pages: trPages,
    toolbar: trToolbar,
  },
  vi: {
    common: viCommon,
    editor: viEditor,
    pages: viPages,
    toolbar: viToolbar,
  },
  th: {
    common: thCommon,
    editor: thEditor,
    pages: thPages,
    toolbar: thToolbar,
  },
  pl: {
    common: plCommon,
    editor: plEditor,
    pages: plPages,
    toolbar: plToolbar,
  },
  uk: {
    common: ukCommon,
    editor: ukEditor,
    pages: ukPages,
    toolbar: ukToolbar,
  },
  ms: {
    common: msCommon,
    editor: msEditor,
    pages: msPages,
    toolbar: msToolbar,
  },
  nl: {
    common: nlCommon,
    editor: nlEditor,
    pages: nlPages,
    toolbar: nlToolbar,
  },
  ur: {
    common: urCommon,
    editor: urEditor,
    pages: urPages,
    toolbar: urToolbar,
  },
  fa: {
    common: faCommon,
    editor: faEditor,
    pages: faPages,
    toolbar: faToolbar,
  },
  tl: {
    common: tlCommon,
    editor: tlEditor,
    pages: tlPages,
    toolbar: tlToolbar,
  },
  ha: {
    common: haCommon,
    editor: haEditor,
    pages: haPages,
    toolbar: haToolbar,
  },
};

i18n
  .use(LanguageDetector) // 检测用户语言
  .use(initReactI18next) // 初始化 react-i18next
  .init({
    resources,
    fallbackLng: fallbackLanguage,
    defaultNS: 'common',
    ns: ['common', 'editor', 'pages', 'toolbar'],
    
    // 语言检测配置
    detection: {
      // 检测顺序：localStorage > 默认语言（不检测 navigator，避免自动切换回浏览器语言）
      order: ['localStorage'],
      caches: ['localStorage'],
      lookupLocalStorage: 'i18nextLng',
      // 如果 localStorage 中没有值，使用默认语言，而不是检测浏览器语言
      checkWhitelist: true, // 只允许支持的语言
    },
    
    // 插值配置
    interpolation: {
      escapeValue: false, // React 已经转义了
    },
    
    // 调试模式（开发环境）
    debug: process.env.NODE_ENV === 'development',
    
    // 如果当前语言不存在，回退到默认语言
    lng: defaultLanguage,
  });

// 确保语言设置持久化：如果 localStorage 中有语言设置，立即应用
if (typeof window !== 'undefined') {
  const savedLanguage = localStorage.getItem('i18nextLng');
  if (savedLanguage && (savedLanguage === 'zh' || savedLanguage === 'en' || savedLanguage === 'zh-TW' || savedLanguage === 'ja' || savedLanguage === 'ko' || savedLanguage === 'es' || savedLanguage === 'pt' || savedLanguage === 'fr' || savedLanguage === 'de' || savedLanguage === 'hi' || savedLanguage === 'ru' || savedLanguage === 'ar' || savedLanguage === 'id' || savedLanguage === 'bn' || savedLanguage === 'it' || savedLanguage === 'tr' || savedLanguage === 'vi' || savedLanguage === 'th' || savedLanguage === 'pl' || savedLanguage === 'uk' || savedLanguage === 'ms' || savedLanguage === 'nl' || savedLanguage === 'ur' || savedLanguage === 'fa' || savedLanguage === 'tl' || savedLanguage === 'ha')) {
    i18n.changeLanguage(savedLanguage);
  }
}

export default i18n;

